import { createEnv } from "@t3-oss/env-core";
import { z } from "zod";

export const env = createEnv({
	clientPrefix: "VITE_",
	client: {
		VITE_BASE_URL: z.url(),
		VITE_POSTHOG_KEY: z.string().optional(),
	},
	runtimeEnv: import.meta.env,
	emptyStringAsUndefined: true,
});

export const VITE_BASE_URL = env.VITE_BASE_URL;

export const isBrowser = typeof window !== "undefined";
